import { render, staticRenderFns } from "./UpdateDemoRequest.vue?vue&type=template&id=d44b3b7c&scoped=true&"
import script from "./UpdateDemoRequest.vue?vue&type=script&lang=js&"
export * from "./UpdateDemoRequest.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDemoRequest.vue?vue&type=style&index=0&id=d44b3b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44b3b7c",
  null
  
)

export default component.exports